/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import DetailCard from '@shared/list-card/detail-card';
import './list-item.scss';

const BaseListItem = ({
  // Data props
  dataType,
  icon,
  id,
  name,
  segments,
  // Handlers
  onClick,
  onMouseEnter,
  onMouseLeave,
  // Render props for customization
  moreButton,
  renderAdditional,
  renderFooterContent,
  styleNames = '',
  // Pass all props to DetailCard
  ...otherProps
}) => {
  const handleClick = useCallback(() => {
    if (onClick) {
      onClick(dataType, id, segments, name, icon);
    }
  }, [dataType, icon, id, name, onClick, segments]);

  const handleMouseEnter = useCallback(() => {
    if (onMouseEnter) {
      onMouseEnter();
    }
  }, [onMouseEnter]);

  const handleMouseLeave = useCallback(() => {
    if (onMouseLeave) {
      onMouseLeave();
    }
  }, [onMouseLeave]);

  const renderActions = () => (
    <div styleName="actions">
      {moreButton}
    </div>
  );

  const renderFooter = () => (
    <div styleName="footer">
      {renderFooterContent ? renderFooterContent() : null}
    </div>
  );

  if (!id) {
    return null;
  }

  const entityProps = {
    dataType,
    icon,
    id,
    name,
    segments,
    ...otherProps
  };

  return (
    <div
      key={id}
      id={`list-item-${id}`}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      role="presentation"
      styleName={`list-item ${styleNames}`}
    >
      <DetailCard
        id={`list-item-${id}`}
        onClick={handleClick}
        onSelect={handleMouseEnter}
        onDeselect={handleMouseLeave}
        entity={entityProps}
        moreButton={renderActions()}
      />
      {renderAdditional ? renderAdditional() : null}
      {renderFooter()}
    </div>
  );
};

BaseListItem.propTypes = {
  dataType: PropTypes.string,
  icon: PropTypes.string,
  id: PropTypes.number,
  moreButton: PropTypes.object,
  name: PropTypes.string,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  renderAdditional: PropTypes.func,
  renderFooterContent: PropTypes.func,
  segments: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  styleNames: PropTypes.string
};

export default memo(BaseListItem);
